import React, { useEffect, useState } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import BasicPagination from "../../../../Pagination/Pagination";
import { Form, Image, Table } from "react-bootstrap";
import { amApi } from "../../../../../api/apiHelper";
import moment from "moment";
import SelectFilter from "../../../../reusableComponents/selectFilter";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import PropTypes, { array } from "prop-types";
import { connect } from "react-redux";
import {
  getAllStateFromCountry,
  getAllCityFromState,
} from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import SelectMapLocation from "../../../../reusableComponents/selectMapLocation/selectMapLocation";
import CSVDownloader from "../../../../reusableComponents/csvDownload/csvDownload";

function RestaurantAnalytics(props) {
  const [platform, setPlatform] = useState("webAApp");

  const [analyticData, setAnalyticData] = useState([]);

  const [searchkey, setsearchkey] = useState("");

  const [dateQuery, setDateQuery] = useState({});

  const [sortOrder, setSortOrder] = useState(true);

  const [sortBy, setSortBy] = useState("QR_SCAN");

  const [isActive, setActive] = useState(false);

  const [showFilter,handleShowFilter] = useState(false);

  const [filteredAnalyticData, setFilteredAnalyticData] = useState([]);

  const [locationPointers, setLocationPointers] = useState({
    markers: [],
    list: [],
  });

  const [locData, setLocData] = useState({
    lat: "",
    lng: "",
    radius: "",
    radiusType: "KMS",
  });

  const [state, setState] = useState({
    city: "",
    state: "",
  });

  const [states, setAllStates] = useState([]);
  const [city, setAllCity] = useState([]);

  const [data, setData] = useState({ country: "", state: "", city: "" });

  const DateForm = {
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  };

  const onDateChangeHandler = (data, type) => {
    setDateQuery(data);
  };

  const onSuccessGetAllStates = (data) => {
    setAllStates(data);
  };

  const onSuccessGetAllCity = (data) => {
    setAllCity(data);
  };

  const onChangeState = (e) => {
    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);
    setData({
      country: data.country,
      [e.target.name]: e.target.value,
      city: "",
    });
    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        setState({
          ...state,
          state: states[i].name,
        });
        break;
      }
    }
  };

  const onChangeCity = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    for (let i = 0; i < city.length; i++) {
      if (e.target.value === city[i].id) {
        setState({
          ...state,
          city: city[i].name,
        });
        break;
      }
    }
  };

  const onLocationSelect = async (loc) => {
    let lat = loc.latLng.lat();
    let lng = loc.latLng.lng();
    setLocData({
      ...locData,
      lat: lat,
      lng: lng,
    });
  };

  const filterData = (data) => {
    return data.filter((item) => {
      return item._id.toLowerCase().includes(searchkey.toLowerCase());
    });
  };

  const resetFilter = async () => {
    await new Promise((resolve) => {
      setLocData({
        ...locData,
        lat: "",
        lng: "",
        radius: "",
      });
      resolve();
    });
  
    await new Promise((resolve) => {
      handleShowFilter(!showFilter);
      resolve();
    });
  
    fetchData(dateQuery.startDate === "undefined" ? DateForm : dateQuery);
  }

  const hanldeFilter = () => {
    fetchData(dateQuery.startDate === "undefined" ? DateForm : dateQuery);
    handleShowFilter(!showFilter)
  }

  const fetchData = async (date) => {
    try {
      const response = await amApi.get(
        `adminPageStats?startDate=${date.startDate}&endDate=${
          date.endDate
        }&sort=${
          sortOrder ? -1 : 1
        }&sortType=${sortBy}&lat=${locData.lat}&long=${locData.lng}&distance=${locData.radius}`
      );
      if (response && response.data) {
        setAnalyticData(response.data);
        setFilteredAnalyticData(response.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(dateQuery.startDate === "undefined" ? DateForm : dateQuery);
  }, [dateQuery, state.city, state.state, sortOrder]);

  useEffect(() => {
    if (analyticData) {
      const filteredData = filterData(analyticData);
      setFilteredAnalyticData(filteredData);
    }
  }, [searchkey, analyticData]);

  useEffect(() => {
    props.getAllStateFromCountry(101, onSuccessGetAllStates);
  }, []);


    /******************************
   * Download Reports
   *****************************/
    const downloadData = {
      headers: [
        { label: "Restaurant Name", key: "restName" },
        { label: "QR Code scans", key: "qrscans" },
        { label: "Menu Views", key: "menu" },
        { label: "Experience Views", key: "Exp" },
        { label: "App Download Button Engagements", key: "App" },
        { label: " No of clicks on View Restaurant Details", key: "viewrestdeyails" },
      ],
      data: filteredAnalyticData
        ? filteredAnalyticData &&
        filteredAnalyticData?.map((ele, index) => {
          return {
            restName: ele?._id,
            qrscans:ele?.QR_SCAN,
            menu:ele?.MENU_VIEW,
            Exp:ele?.EXP_VIEW,
            App:ele?.APP_DOWNLOAD,
            viewrestdeyails:ele?.RESTAURANT_VIEW,
          };
        })
        : [],
    };

  return (
    <div>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation displayText="Reports" />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex  align-items-center justify-content-between pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">Restaurants</div>
              </div>
              <div className="my-3">
                <Select
                  variant="outlined"
                  value={platform}
                  onChange={(e) => setPlatform(e.target.value)}
                  autoWidth={true}
                  sx={{ width: "100%" }}
                  className="pr-4"
                >
                  <MenuItem value={"All"}> All </MenuItem>
                  <MenuItem value={"userApp"}>User App Activity </MenuItem>
                  <MenuItem value={"webAApp"}> Web App Activity </MenuItem>
                </Select>
              </div>
              <div className="row">
                <div className="col-5 d-flex align-items-center pl-0">
                  <div  className={`newexpandablesearch mx-2  mb-2 ${isActive ? "active" : null}`}>
                    <div className="searchicon">
                      <i
                        onClick={() => {
                          setActive(!isActive);
                        }}
                        className="fa fa-search"
                        aria-hidden="true"
                        style={{ fontSize: "20px" }}
                      ></i>
                    </div>
                    <div className="input">
                      <Form.Control
                        type="text"
                        placeholder="search by restaurants"
                        className="newsearchinput"
                        onChange={(e) => setsearchkey(e.target.value)}
                        value={searchkey}
                        style={{ borderRadius: "28px" }}
                      />
                      <i className="fa fa-timesw" aria-hidden="true"></i>
                    </div>
                  </div>
                  <div
                    className="f10-400"
                    align="center"
                    onClick={() => handleShowFilter(!showFilter)}
                  >
                    <img
                      src={require("../../../../../assets/images/iconButton/filterbtn.svg")}
                      width="80px"
                    />
                    <br />
                  </div>

                  <CSVDownloader
                    filename={"Restaurants Analytics"}
                    headers={downloadData.headers}
                    data={downloadData.data}
                  />
                </div>
                <div className="col-3"></div>
                <div className="col-4 d-flex justify-content-end align-items-center">
                  <div className="mr-3">
                    <SelectFilter onDateChange={onDateChangeHandler} />
                  </div>
                </div>
              </div>
              {/* <div className="d-flex justify-content-between my-2 ">
                <div className="d-flex align-items-center custom-border">
                  <div style={{ borderRight: "1px solid #80808052" }}>
                    <Form.Control
                      type="text"
                      placeholder="Search by Restaurants"
                      name="search"
                      onChange={(e) => setsearchkey(e.target.value)}
                      value={searchkey}
                      className="amSearch"
                    />
                  </div>

                  <div className="mx-2">
                    <FormControl>
                      <InputLabel id="demo-simple-select-label">
                        State
                      </InputLabel>
                      <Select
                        style={{ width: "100%" }}
                        value={data.state}
                        onChange={onChangeState}
                        inputProps={{
                          name: "state",
                          id: "outlined-state",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                        className="mx-2"
                      >
                        <MenuItem value="" disabled>
                          <em>Select County</em>
                        </MenuItem>
                        {states.map((state, index) => (
                          <MenuItem key={index} value={state.id}>
                            {state.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="px-4">
                    <FormControl>
                      <InputLabel id="demo-simple-select-label">
                        city
                      </InputLabel>
                      <Select
                        className="mx-2"
                        style={{ width: "100%" }}
                        value={data.city}
                        onChange={onChangeCity}
                        inputProps={{
                          name: "city",
                          id: "outlined-state",
                        }}
                        IconComponent={KeyboardArrowDownIcon}
                      >
                        <MenuItem value="" disabled>
                          <em>Select City</em>
                        </MenuItem>
                        {city.map((city, index) => (
                          <MenuItem key={index} value={city.id}>
                            {city.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  {/* <div className="mx-2">
                    <div className="f14-400 opacity-50">
                      {" "}
                      within <span className="f14-700 mx-1">5</span>km radius{" "}
                    </div>
                  </div> 
                </div>
                <div className="mr-3">
                  <SelectFilter onDateChange={onDateChangeHandler} />
                </div>
              </div> */}
              {showFilter && (
              <div className="d-flex">
                <div className="col-8">
                  <SelectMapLocation
                    location={locationPointers}
                    onSelectLocation={onLocationSelect}
                  />
                </div>
                <div className="col-4">
                  <div className="py-4">
                    <TextField
                      id="latitude"
                      type="number"
                      value={locData.lat}
                      label="Latitude"
                      variant="outlined"
                      className={`w-100`}
                      name="latitude"
                      onChange={(e) =>
                        setLocData({ ...locData, lat: e.target.value })
                      }
                    />
                  </div>
                  <div className="py-4">
                    <TextField
                      id="longitude"
                      type="number"
                      value={locData.lng}
                      label="Longitude"
                      variant="outlined"
                      className={`w-100`}
                      name="longitude"
                      onChange={(e) =>
                        setLocData({ ...locData, lng: e.target.value })
                      }
                    />
                  </div>
                  <p className="py-4 f16-700"> Within the Radius of</p>
                  <div className="d-flex">
                    <div className="col-8">
                      <TextField
                        id="radius"
                        type="number"
                        label="Radius"
                        variant="outlined"
                        className={`w-100`}
                        name="radius"
                        onChange={(e) =>
                          setLocData({ ...locData, radius: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  <div class="d-flex align-items-center mt-4">
                      <button
                        type="button"
                        className="btn-md mr-4 px-5 btn btn-outline-secondary"
                        onClick={resetFilter}
                      >
                        Reset
                      </button>
                      <button
                        type="button"
                        className="btn-md px-5 btn btn-danger"
                        onClick={hanldeFilter}
                      >
                        Apply Filter
                      </button>
                    </div>
                </div>
              </div>
              )}
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin super-admin-all-vendor-main">
                  <Table className="">
                    <thead>
                      <tr className="super_admin_all_users_table_head">
                        <td style={{ width: "20%" }} className="f12-400 ml-2">
                          Restaurant Name
                        </td>
                        <td
                          style={{ width: "15%" }}
                          className="f12-400 d-flex align-items-center"
                        >
                          <div>
                            Number of <br />
                            QR Code scans
                          </div>

                          <div
                            className="ml-2"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              setSortOrder(!sortOrder);
                            }}
                          >
                            <Image
                              alt="Sort"
                              title="Sort"
                              width="20px"
                              src={require("../../../../../assets/images/iconButton/ntimer.png")}
                            />
                          </div>
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Menu Views
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Experience Views
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          App Download Button <br /> Engagements
                        </td>
                        <td style={{ width: "15%" }} className="f12-400">
                          Number of clicks on <br /> "View Restaurant Details."
                        </td>
                      </tr>
                    </thead>
                    {filteredAnalyticData ? (
                      filteredAnalyticData?.map((data) => {
                        return (
                          <tbody className="w-100 super-admin-all-vendor-main-table-body">
                            <tr className="w-100 p-0">
                              <td className="p-0 w-100">
                                <table className="w-100">
                                  <tbody className="sd_body_css">
                                    <tr className="sd_body_table-row super-admin-list-icon-image">
                                      <td style={{ width: "20%" }}>
                                        <div className="f12-400">
                                          {data?._id}
                                        </div>
                                      </td>
                                      <td style={{ width: "17%" }}>
                                        <div className="f12-400">
                                          {data.QR_SCAN}
                                        </div>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <div className="f12-400">
                                          {data.MENU_VIEW}
                                        </div>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <div className="f12-400">
                                          {data.EXP_VIEW}
                                        </div>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <div className="f12-400">
                                          {data.APP_DOWNLOAD}
                                        </div>
                                      </td>
                                      <td style={{ width: "15%" }}>
                                        <div className="f12-400">
                                          {data.RESTAURANT_VIEW}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        );
                      })
                    ) : (
                      <>No Data</>
                    )}
                  </Table>
                  <div className="row w-100">
                    <div className="col-12">
                      <BasicPagination
                        totalRecords={10}
                        limit={10}
                        batch={1}
                        onBatchChange={(e) => e}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

RestaurantAnalytics.propTypes = {
  auth: PropTypes.object.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  getAllStateFromCountry,
  getAllCityFromState,
})(RestaurantAnalytics);
